import routerOptions0 from "/codebuild/output/src3921127278/src/Conversational-bot/client/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions0,
}